import { IGetStepContentProductsResponse } from "../types";

export const mockGetStepContentProductsResponse: IGetStepContentProductsResponse = {
  result: {
    metadata: {
      invitedByOrganisationName: "Balfour Beatty"
    },
    recommended: {
      productSalesTypeId: 47,
      productSiloId: 1,
      siloName: "Constructionline",
      name: "Gold",
      description:
        "Our Gold membership enables you to go beyond the PAS91 and easily demonstrate your ability to meet the Common Assessment Standard.",
      shortDescription:
        "All the benefits for Gold membership and also meet the Common Assessment Standard",
      isRecommended: true,
      icon: "cl-gold",
      primaryColor: "#E3D17E",
      secondaryColor: "#D0B22A",
      benefits: ["Stand out to top buyers who work only with Gold members"],
      benefitIcons: [
        {
          icon: "https://example.com/icons/ssip.svg",
          tooltip: "Safety Schemes in Procurement",
          altText: "Circle logo of SSIP (Safety Schemes in Procurement)"
        },
        {
          icon: "https://example.com/icons/cas.svg",
          tooltip: "Common Assessment Standard",
          altText: "Circle logo of the Common Assessment Standard shortened to CAS overlaid"
        }
      ],
      offer: {
        title: "Monthly Cost {trialGrossAmount}",
        description: "Put your business before the UK's largest network of construction buyers",
        terms: "Billed annually [netAmount] excl VAT\nplus {joiningFeeAmount} one-off joining fee"
      },
      sidebar: {
        quote: {
          text: "We use Constructionline Gold on a regular basis as one of our solutions",
          authorName: "Ryan Radley (Gold)",
          authorPosition: "Head of Commercial Estimating (Gold)",
          authorCompany: "Dempsey Dyer (Gold)"
        }
      }
    },
    productCards: [
      {
        productSalesTypeId: 1,
        productSiloId: 1,
        siloName: "Constructionline",
        name: "Bronze",
        description: "TBD (Bronze)",
        shortDescription: "Manage your insurance and SSIP data through a simplified question set.",
        isRecommended: false,
        icon: "cl-bronze",
        primaryColor: "#DAA973",
        secondaryColor: "#C77E32",
        benefits: ["A streamlined simplified questionnaire to verify capability"],
        benefitIcons: [
          {
            icon: "https://example.com/icons/ssip.svg",
            tooltip: "Safety Schemes in Procurement",
            altText: "Circle logo of SSIP (Safety Schemes in Procurement)"
          }
        ],
        offer: {
          title: "Monthly Cost {trialGrossAmount}",
          description: "Put your business before the UK's largest network of construction buyers",
          terms: "Billed annually [netAmount] excl VAT\nplus {joiningFeeAmount} one-off joining fee"
        },
        sidebar: {
          quote: {
            text: "We use Constructionline Bronze on a regular basis as one of our solutions",
            authorName: "Ryan Radley (Bronze)",
            authorPosition: "Head of Commercial Estimating (Bronze)",
            authorCompany: "Dempsey Dyer (Bronze)"
          }
        }
      },
      {
        productSalesTypeId: 24,
        productSiloId: 1,
        siloName: "Constructionline",
        name: "Silver",
        description: "TBD (Silver)",
        shortDescription:
          "Share your compliance and SSIP data with the largest construction and FM buyers.",
        isRecommended: false,
        icon: "cl-silver",
        primaryColor: "#DDDEDE",
        secondaryColor: "#AAADAD",
        benefits: ["A simpler way to verify your capability to meet PAS91 standard"],
        benefitIcons: [
          {
            icon: "https://example.com/icons/ssip.svg",
            tooltip: "Safety Schemes in Procurement",
            altText: "Circle logo of SSIP (Safety Schemes in Procurement)"
          },
          {
            icon: "https://example.com/icons/cas.svg",
            tooltip: "Common Assessment Standard",
            altText: "Circle logo of the Common Assessment Standard shortened to CAS overlaid"
          }
        ],
        offer: {
          title: "Monthly Cost {trialGrossAmount}",
          description: "Put your business before the UK's largest network of construction buyers",
          terms: "Billed annually [netAmount] excl VAT\nplus {joiningFeeAmount} one-off joining fee"
        },
        sidebar: {
          quote: {
            text: "We use Constructionline Silver on a regular basis as one of our solutions",
            authorName: "Ryan Radley (Silver)",
            authorPosition: "Head of Commercial Estimating (Silver)",
            authorCompany: "Dempsey Dyer (Silver)"
          }
        }
      },
      {
        productSalesTypeId: 47,
        productSiloId: 1,
        siloName: "Constructionline",
        name: "Gold",
        description:
          "Our Gold membership enables you to go beyond the PAS91 and easily demonstrate your ability to meet the Common Assessment Standard.",
        shortDescription:
          "All the benefits for Gold membership and also meet the Common Assessment Standard",
        isRecommended: true,
        icon: "cl-gold",
        primaryColor: "#E3D17E",
        secondaryColor: "#D0B22A",
        benefits: ["Stand out to top buyers who work only with Gold members"],
        benefitIcons: [
          {
            icon: "https://example.com/icons/ssip.svg",
            tooltip: "Safety Schemes in Procurement",
            altText: "Circle logo of SSIP (Safety Schemes in Procurement)"
          },
          {
            icon: "https://example.com/icons/cas.svg",
            tooltip: "Common Assessment Standard",
            altText: "Circle logo of the Common Assessment Standard shortened to CAS overlaid"
          },
          {
            icon: "https://example.com/icons/bsa.svg",
            tooltip: "Building Safety Act",
            altText:
              "Purple circle with a white shield with BSA written in the middle to represent the Building Safety Act"
          }
        ],
        offer: {
          title: "Monthly Cost {trialGrossAmount}",
          description: "Put your business before the UK's largest network of construction buyers",
          terms: "Billed annually [netAmount] excl VAT\nplus {joiningFeeAmount} one-off joining fee"
        },
        sidebar: {
          quote: {
            text: "We use Constructionline Gold on a regular basis as one of our solutions",
            authorName: "Ryan Radley (Gold)",
            authorPosition: "Head of Commercial Estimating (Gold)",
            authorCompany: "Dempsey Dyer (Gold)"
          }
        }
      },
      {
        productSalesTypeId: 70,
        productSiloId: 1,
        siloName: "Constructionline",
        name: "Platinum",
        description: "TBD (Platinum)",
        shortDescription: "TBD (Platinum)",
        isRecommended: false,
        icon: "cl-platinum",
        primaryColor: "#AFB1B2",
        secondaryColor: "#7C7F82",
        benefits: ["Enhance validation to prove your ability to go beyond PAS 91"],
        benefitIcons: [
          {
            icon: "https://example.com/icons/ssip.svg",
            tooltip: "Safety Schemes in Procurement",
            altText: "Circle logo of SSIP (Safety Schemes in Procurement)"
          },
          {
            icon: "https://example.com/icons/cas.svg",
            tooltip: "Common Assessment Standard",
            altText: "Circle logo of the Common Assessment Standard shortened to CAS overlaid"
          },
          {
            icon: "https://example.com/icons/bsa.svg",
            tooltip: "Building Safety Act",
            altText:
              "Purple circle with a white shield with BSA written in the middle to represent the Building Safety Act"
          }
        ],
        offer: {
          title: "Monthly Cost {trialGrossAmount}",
          description: "Put your business before the UK's largest network of construction buyers",
          terms: "Billed annually [netAmount] excl VAT\nplus {joiningFeeAmount} one-off joining fee"
        },
        sidebar: {
          quote: {
            text: "We use Constructionline Platinum on a regular basis as one of our solutions",
            authorName: "Ryan Radley (Platinum)",
            authorPosition: "Head of Commercial Estimating (Platinum)",
            authorCompany: "Dempsey Dyer (Platinum)"
          }
        }
      }
    ]
  },
  isSuccess: true,
  message: "Found 4 product(s) for 'metal-product-selection'.",
  validationIssues: null
};
